import { Injectable } from '@angular/core';
import { CacheStorage, QueryBus, Wrapper } from '@skylab-angular-shared/core';
import { QuickListDataSourceFactoryBase } from '@skylab-shared/business';

export { QuickListDataSourceFactoryBase };

@Injectable({ providedIn: 'root'})
@Wrapper(QuickListDataSourceFactoryBase)
export class QuickListDataSourceFactory {
    public constructor(
        queryBus: QueryBus,
        cacheStorage: CacheStorage
    ) { }
}
